import { CampaignSipTrunkCreateRequestDto } from '@shared/services/apiService/apiService';
import { CampaignSipTrunkValue } from '../model/type';
import { SipTrunkType } from '@shared/constants/campaign.constants';

export const campaignSipTrunkCreateRequestMapper = (data: CampaignSipTrunkValue) => {
  const mappedForm: CampaignSipTrunkCreateRequestDto = {
    type: data.type,
    numbers: data.numbers,
  };

  if (data.type === SipTrunkType.OUTBOUND) {
    mappedForm.authUsername = data.authUsername;
    mappedForm.authPassword = data.authPassword;
    mappedForm.address = data.address;
    if (data.transport) {
      mappedForm.transport = data.transport;
    }
  } else {
    mappedForm.allowedAddresses = data.allowedAddresses;
  }

  return mappedForm;
};
